<page-load-header *ngIf="!initialized"></page-load-header>
<div class="container">
  <h3>My Breakout Reservations</h3>
  <div class="row no-gutters no-candidates " style="min-height: 200px" *ngIf="(initialized && (!events || events.length == 0)) || !auth.isLoggedIn()">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Reservations</h4>
      <p>You don't have any breakout reservations. Please make sure you are logged in with the correct email.</p>
    </div>
  </div>
  <ng-container *ngFor="let event of events">
    <div class="border-bottom mb-5">
      <bxl-event-item [rootRoute]="'/' + slug" [event]="$any(event)"></bxl-event-item>
    </div>
  </ng-container>
</div>
